import { BankHelper } from '../utils/bank.helper';
export const ibanValid = (iban) => {
    const valid = BankHelper.validate(iban);
    if (!valid) {
        return "L'IBAN n'est pas valide";
    }
    return true;
};
export const bicValid = (bic) => {
    const valid = BankHelper.bicIsValid(bic);
    if (!valid) {
        return "Le BIC n'est pas valide";
    }
    return true;
};
